export const LOGIN_VIEW = "login";
export const PASSWORD_RESET_VIEW = "pass-reset";
export const LOGIN_2FA = "login-second-factor";

export const paginationStyle = (theme, themeMode) => {
  return {
    ".MuiDataGrid-columnSeparator svg": {
      opacity: themeMode === "dark" ? ".3" : "1",
    },
    ".MuiDataGrid-columnHeader button svg": {
      color: theme.palette.colorFont,
    },
    ".MuiToolbar-root": {
      color: theme.palette.colorFont,
    },
    ".MuiSelect-icon": {
      color: theme.palette.colorFont,
    },
    ".MuiTablePagination-actions": {
      color: theme.palette.colorFont,
      ".Mui-disabled svg": {
        color: theme.palette.colorFont,
        opacity: ".5",
      },
    },
    // ".MuiDataGrid-pinnedColumnHeaders, .MuiDataGrid-pinnedColumns": {
    //   backgroundColor: themeMode === "dark" ? "#1e1e1e" : theme.palette.background.paper,
    //   color: theme.palette.colorFont,
    //   "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
    //     backgroundColor: themeMode === "dark" ? "#1e1e1e" : theme.palette.background.paper,
    //     color: theme.palette.colorFont,
    //     borderRight: `1px solid ${
    //       theme.palette.divider || theme.palette.colors?.borderColor || "#ccc"
    //     }`,
    //   },
    // },
  };
};

export const serviceNames = {
  personnel: "personnel",
  perEmergencyContact: "per-emergency-contact",
  personnelPhotos: "personnel-photos",
  personnelTag: "personnel-tag",
  userSettings: "per-user-settings",
  codePerTags: "code-per-tags",
  perApplicant: "per-applicant",
  trainingCourse: "training-course",
  perTraining: "per-training",
  perTrainigDistinct: "per-training/distinct",
  perTrainingCertification: "per-training-certification",
  trainingCourseDistinct: "training-course/distinct",
  perTrainingCertificationDistinct: "per-training-certification/distinct",
  perTrainingCost: "per-training-cost",
  trainingSummary: "training-summary",
  codePerEmploymentStatus: "code-per-employment-status",
  customId: "custom-ids",
  codePerTrainingCost: "code-per-training-cost",
  perNotes: "per-notes",
  searchPeople: "search-person-ams",
  perAssignmentHistory: "per-personnel-assignment-history",
  perEmergencyContactDistinct: "per-emergency-contact/distinct",
  codeCounties: "codecounties",
  codeSex: "codesex",
  codeRank: "coderanks",
  codeRace: "coderace",
  codeEthnicity: "codeethnicity",
  codeSuffix: "codenamesuffixes",
  codeContactInfo: "codecontactinfomethodtypes",
  codeState: "codestates",
  codeBloodType: "codebloodtype",
  codeMaritalStatus: "codemaritalstatus",
  codeCity: "codecities",
  codeNameSuffix: "codenamesuffixes",
  codePerEmployementStatus: "code-per-employment-status",
  codePerTitlePosition: "code-per-title-position",
  codePerDepartment: "code-per-department",
  codePerSection: "code-per-section",
  codePerEducation: "code-per-education",
  codePerApplicantStatus: "code-per-applicant-status",
  codePerApplicantTestResult: "code-per-applicant-test-result",
  perApplicantYearOptions: "per-applicant/year-options",
  ptsAgencies: "ptsagencies",
  codeEmployeementStatus: "codeEmploymentstatuses",
  codeAssociateRelationships: "codeassociaterelationships",
  settingsSecuritySearchProfilesAms: "settings-security-search-profiles-ams",
  settingsSecuritySearchProfiles: "settings-security-search-profiles",
  settingsSecGroupAms: "settings-sec-group-ams",
  settingsSecProfileGroupsAms: "settings-sec-profile-groups-ams",
  settingsSecuritySearchUsersAms: "settings-security-search-users-ams",
  ptsContactInfo: "ptscontactinfo",
  settingsSecClearanceLevel: "settings-sec-clearance-level",
  settingsSecComponentAms: "settings-sec-component-ams",
  settingsSecGroupComponentsAms: "settings-sec-group-components-ams",
  settingsSecurityPermissionsAppsAms: "settings-security-permissions-apps-ams",
  settingsSecurityClearanceLevels: "settings-security-clearance-levels",
  settingsSecurityUsersHistory: "settings-security-users-history",
  settingsSecurityCodes: "settings-security-codes",
  settingsCreateNewPermissionAms: "settings-create-new-permission-ams",
  settingsDefaultPermissionsAms: "settings-default-permissions-ams",
  settingsCodesPermissionsAms: "settings-codes-permissions-ams",
  secProfileAms: "secprofileams",
  permissionsAms: "permissions-ams",
  CDR: "cdr",
  perFilters: "per-filters",
  amsDictionary: "ams-dictionary",
  secUser: "sec-user",
  amsReportViewer: "ams-report-viewer",
  // Fleet Management
  codePerEquipmentCategory: "code-per-equipment-category",
  codePerEquipmentConditions: "code-per-equipment-conditions",
  codePerEquipmentServiceRequirements: "code-per-equipment-service-requirements",
  codePerEquipmentStatus: "code-per-equipment-status",
  codePerEquipmentTypes: "code-per-equipment-types",
  codePerInspectionTypes: "code-per-inspection-types",
  codePerVehicleServiceRequirements: "code-per-vehicle-service-requirements",
  codePerVehicleStatus: "code-per-vehicle-status",
  codePerWorkOrderStatus: "code-per-work-order-status",
  codePerWorkOrderTypes: "code-per-work-order-types",
  perChecklistItemInspectionTypes: "per-checklist-item-inspection-types",
  perChecklistItems: "per-checklist-items",
  perDispensableIssuances: "per-dispensable-issuances",
  perDispensableItems: "per-dispensable-items",
  perDispensableVendorOptions: "/per-dispensable-items/vendor-options",
  perEquipmentAssignmentHistory: "per-equipment-assignment-history",
  perEquipmentMaintenance: "per-equipment-maintenance",
  perEquipmentServiceRequirementLinks: "per-equipment-service-requirement-links",
  perEquipment: "per-equipment",
  perFundingSources: "per-funding-sources",
  perFundingSourceOptions: "per-funding-sources/source-options",
  perFundingAdministratorOptions: "per-funding-sources/administrator-options",
  perInspections: "per-inspections",
  perInspectionResponses: "per-inspection-responses",
  perVehicleServiceRequirements: "per-vehicle-service-requirements",
  perVehicles: "per-vehicles",
  perVehicleMakeOptions: "per-vehicles/make-options",
  perVehicleModelOptions: "per-vehicles/model-options",
  perVehicleYearOptions: "per-vehicles/year-options",
  perWorkOrders: "per-work-orders",
  perEquipmentBrandOptions: 'per-equipment/brand-options',
  perEquipmentStyleOptions: 'per-equipment/style-options',
  perEquipmentCaliberOptions: 'per-equipment/caliber-options',
  perEquipmentSightsOptions: 'per-equipment/sights-options',
  perEquipmentLocationOptions: 'per-equipment/location-options',
  perEquipmentPurchasedFromOptions: 'per-equipment/purchased-from-options',
  perVehicleAssignmentHistory: 'per-vehicle-assignment-history',
  perVehicleNotes: 'per-vehicle-notes',
  perAuditLog: 'per-audit-log',
};

export const entityNamesForCustomId = {
  personnelEmployeeId: "PersonnelEmployeeId",
  people: "People",
  CourseId: "CourseId",
  CertificateId: "CertificateId",
  ParticipantId: "ParticipantId",
  FleetId: "FleetId",
  WorkOrderId: "WorkOrderId",
  InspectionId: "InspectionId",
  FundingSourceId: "FundingSourceId",
  EquipmentId: "EquipmentId",
  MaintenanceId: "MaintenanceId",
  DispensableId: "DispensableId",
};

export const messages = {
  otpSent: "Authentication token has been sent (email)",
};

export const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

export const muiV4Breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

export const permissionLabelOptions = {
  modules: [
    "Applicants",
    "Employees",
    "Training",
    "Security",
    "Codes",
    "RMS",
    "CAD",
    "Archive",
    "Settings",
    "Mobile",
    "Analytics",
  ],
  security: ["Profiles", "Roles And Permissions"],
  applicants: [
    "Applicant Record",
    "General Info",
    "Additional Info",
    "Tags",
    "Notes",
    "Photos",
  ],
  employees: [
    "Employee Record",
    "General Info",
    "Assignment History",
    "Separation",
    "Tags",
    "Education",
    "Photos",
    "Payroll",
    "Medical Fields",
    "Emergency Contact",
    "Notes",
  ],
  training: [
    "Courses",
    "Participants",
    "Certifications",
    "Mass Update",
    "Summary",
    "Course Information",
    "Course Participant",
    "Course Certificate Information",
    "Course Tags",
    "Participant Information",
    "Training Cost",
    "Participant Tags",
    "Certificate Information",
    "Certificate Tags",
  ],
  codes: [
    "Applicant Status",
    "Applicant Test Result",
    "Education",
    "Department",
    "Employment Status",
    "Rank",
    "Relationship",
    "Section",
    "Title",
    "Training Cost",
  ],
};

export const screenNames = {
  employees: "Employees",
  employeesView: "EmployeesView",
  applicants: "Applicants",
  courses: "Courses",
  participants: "Participants",
  certifications: "Certifications",
  trainingSummary: "Training Summary",
}

export const employeesView = {
  employeeGridView: "employeeGridView",
  employeeCardView: "employeeCardView",
}

export const AMSReportID = {
  Applicants: 315,
  Employees: 316,
  Courses: 317,
  TrainingRecords: 318,
  Certifications: 319,
}

export const AMSModules = {
  Applicants: "Applicants",
  Employees: "Employees",
  Courses: "Courses",
  Participants: "Participants",
  Certifications: "Certifications",
  Summary: "Summary",
  LogOut: "LogOut",
  Vehicles: "Vehicles",
  WorkOrders: "WorkOrders",
  Inspections: "Inspections",
  Maintenance: "Maintenance",
  DispensableItems: "DispensableItems",
  Equipments: "Equipments",
  FundingSources: "FundingSources",
  Fleet: "Fleet",
  Equipment: "Equipment",
}
